import * as types from './mutation-types'
import Vue from 'vue'
import { fetch } from '@/commons/fetch'
import { requestUrl, requestTopicUrl } from '@/commons/config'
import { showLoginBox, jin10Login } from '@/commons'
import { addScript } from '@/commons/utils'
import { BUS } from '@/views/tv/main'
import { BusEvent } from '@/commons/constants'
import { getServiceQRCode as apiGetServiceQRCode } from '@/apis'
import { getDingMemberInfo, getRemoteDingShowConfig } from '../apis/qh-ding'

const setChatState = (datas) => {
  const chatVm = Vue.prototype.$chatVm
  if (!chatVm) {
    return false
  }
  chatVm.$store.dispatch('getRegState', chatVm)
  chatVm.$store.dispatch('setLoginState', {
    type: 'login',
    datas: {
      data: datas
    }
  })
  chatVm.$store.dispatch('getCanChangeNickState', chatVm)
  if (typeof CHAT_SOCKET !== 'undefined') {
    CHAT_SOCKET.reconnect()
  }
}

/**
 * 获取用户数据
 */
export const getUser = ({ state, commit }, params) => {
  return new Promise((resolve, reject) => {
    jin10Login.getUser({ forceUpdate: true }).then((data) => {
      commit(types.UPDATE_USER, data)
      resolve(data)
    }).catch((e) => {
      commit(types.UPDATE_USER, { fail: true })
      reject(e)
    })
  })
}

export const setUser = ({ commit }, data) => {
  commit(types.UPDATE_USER, data)
}

/**
 *获取配置数据
 */
export const getOpation = ({ commit }) => {
  return new Promise((resolve, reject) => {
    addScript(requestUrl.configs + '?' + Date.now(), () => {
      let datas = window.GENERAL_CHANNEL_CONFIG
      datas = {
        ...datas,
        'live-btnws': {
          roomID: 39
        }
      }
      commit(types.UPDATE_OPTIONS, datas)
      resolve(datas)
    })
    // fetch({
    //   url: requestUrl.configs + '?' + Date.now(),
    //   type: 'get',
    //   success (datas) {
    //     commit(types.UPDATE_OPTIONS, datas)
    //     resolve(window.GENERAL_CHANNEL_CONFIG)
    //   },
    //   error () {
    //     setTimeout(() => {
    //       getOpation({ commit })
    //     }, 2000)
    //   }
    // })
  })
}

export const setAppUserDataState = ({ commit }, isFetchAppUserData) => {
  commit(types.UPDATE_FETCH_APP_USER_DATA_STATE, isFetchAppUserData)
}

export const setLiveType = ({ commit, getters }, type) => {
  commit(types.UPDATE_LIVE_TYPE, type)
  commit(types.UPDATE_LIVE_INFO, getters.options[type])
}

export const setLiveInfo = ({ commit }, payload) => {
  commit(types.UPDATE_LIVE_INFO, payload)
}

export const setLiveUrl = ({ commit }, url) => {
  commit(types.UPDATE_LIVE_URL, url)
}

export const setLiveState = ({ commit }, isLive) => {
  commit(types.UPDATE_LIVE_CURRENT_STATE, isLive)
}

export const setChannelLiveState = ({ commit }, payload) => {
  commit(types.UPDATE_CHANNEL_LIVE_STATE, payload)
}

export const setChatReadyState = ({ commit }, isReady) => {
  commit(types.UPDATE_CHAT_READY_STATE, isReady)
}

export const checkDevice = ({ commit }, isMobile) => {
  commit(types.CHECK_DEVICE, isMobile)
}

export const updateServerTime = ({ commit }, time) => {
  commit(types.UPDATE_SERVER_TIME, time)
}

export const setPosterUrl = ({ commit }, url) => {
  commit(types.UPDATE_POSTER_URL, url)
}

export const setEmcee = ({ commit }, name) => {
  commit(types.UPDATE_EMCEE, name)
}

export const setVideoID = ({ commit }, id) => {
  commit(types.UPDATE_VIDEO_ID, id)
}

export const setTradingVideoID = ({ commit }, id) => {
  commit(types.UPDATE_TRADING_VIDEO_ID, id)
}

export const setPrevueTime = ({ commit }, time) => {
  commit(types.UPDATE_PREVUE_TIME, time)
}

export const setFmLivePlayState = ({ commit }, isPlay) => {
  commit(types.UPDATE_FM_LIVE_PLAY_STATE, isPlay)
}

export const setFmReplayState = ({ commit }, isPlay) => {
  commit(types.UPDATE_FM_REPLAY_STATE, isPlay)
}

export const setFmVideo = ({ commit }, payload) => {
  commit(types.UPDATE_FM_VIDEO, payload)
}

export const setFmEmmecNotice = ({ commit }, notice) => {
  commit(types.UPDATE_FM_EMMEC_NOTICE, notice)
}

export const setFmSignVisibleState = ({ commit }, isShow) => {
  commit(types.UPDATE_FM_SIGN_VISIBLE, isShow)
}

export const setWeekTalkDatas = ({ commit }, payload) => {
  commit(types.UPDATE_WEEK_TALK_DATAS, payload)
}

const allWeelky = {}
export const getWeekTalkDatas = (store, id) => {
  return new Promise((resolve, reject) => {
    fetch({
      type: 'get',
      url: `${requestTopicUrl.weekTalk.replace('{id}', id)}?${Date.now()}`,
      success: (datas) => {
        if (!allWeelky[id]) {
          allWeelky[id] = datas
        }
        setWeekTalkDatas(store, allWeelky[id])
        resolve(datas)
      }
    })
  })
}

export const getWeekTalkID = (store) => {
  return new Promise((resolve, reject) => {
    fetch({
      type: 'get',
      url: `${requestTopicUrl.config}?${Date.now()}`,
      success: (datas) => {
        let id = datas.latestId
        setWeekTalkDatas(store, {
          id
        })
        resolve(id)
      }
    })
  })
}

/**
 * 显示登录框
 * @param {String} type 默认是login，还有register，bindmobile
 * 绑定手机成功后，可以去watch user.bindmobile，当值变化为1的时候说明绑定成功
 */
let isShowLogin = false
export const showLogin = ({ commit, state }, type) => {
  // 防止快速点击时造成的问题
  if (isShowLogin) {
    return false
  }
  isShowLogin = true
  setTimeout(() => {
    isShowLogin = false
  }, 1000)
  type = type || 'login'
  return new Promise((resolve) => {
    showLoginBox({
      embedded: type === 'embedded',
      loginCallback (datas) {
        commit(types.UPDATE_USER, datas)
        setChatState(datas)
        BUS.$emit(BusEvent.REFRESH_LIVE_INFO)
        resolve()
      },
      oauthCallback (a) {
        if (document.getElementById('J_comment')) {
          location.reload()
          return false
        }
        getUser({ commit }).then((data) => {
          setChatState({ data })
          resolve()
        })
      },
      bindCallback () {
        Vue.set(state.user, 'bindmobile', 1)
      },
      type: type === 'embedded' ? 'login' : type
    })
  })
}

export const setPageType = ({ commit }, type) => {
  commit(types.SET_PAGE_TYPE, type)
}

export const setVipState = ({ commit }, type) => {
  commit(types.SET_VIP_STATE, type)
}

export const setTrySeeRemain = ({commit}, data) => {
  commit(types.SET_TRY_FREE_REMAIN, data)
}

export const getServiceQRCode = async ({commit}, data) => {
  try {
    const { data } = await apiGetServiceQRCode()
    commit(types.SET_SERVICE_QRCODE, data.data.formData.list)
  } catch (error) {
    console.error(error)
  }
}

export const setLocalTime = ({commit}) => {
  commit(types.SET_LOCAL_TIME)
}

export const setTopNavs = ({commit}, data) => {
  commit(types.SET_TOP_NAVS, data)
}

export const setWindowWidth = ({commit}, data) => {
  commit(types.SET_WINDOW_WIDTH, data)
}

export const getDingInfo = async ({commit}) => {
  try {
    const { data } = await getDingMemberInfo()
    if (data.status === 200 && data.data) {
      const hasBuyList = data.data.filter(it => it.is_expired === false && it.product_gid !== 'qh_all_monitor')
        .map(it => it.product_gid)
      commit(types.SET_HAS_BUY_DING, hasBuyList.length)
      commit(types.SET_HAS_GET_DING_INFO, true)
    }
  } catch (error) {
    commit(types.SET_HAS_GET_DING_INFO, true)
    console.error(error)
  }
}

export const getDingShowConfig = async ({commit}) => {
  try {
    const { data } = await getRemoteDingShowConfig()
    console.log('%c data', 'color: red', data)
    commit(types.SET_DING_SHOW_CONFIG, data.data.data.formData.ding_live)
  } catch (error) {
    console.error(error)
  }
}

export const updateRoomInfo = ({commit}, data) => {
  commit(types.UPDATE_ROOM_INFO, data)
}



// WEBPACK FOOTER //
// ./src/store/actions.js